module.exports = __webpack_public_path__ + "static/rainbird-69ba50d3f772622b5fcb6353364b6bd8.png";